module.exports = __webpack_public_path__ + "img/iconApp.541ba74e.svg";